
export const replaceIdWithUUID = (obj) => {
  const json = JSON.parse(JSON.stringify(obj).replaceAll("\"id\":", "\"uuid\":"));
  return json;
}

export const replaceUUIDWithId = (obj) => {
  const json = JSON.parse(JSON.stringify(obj).replaceAll("\"uuid\":", "\"id\":"));
  return json;
}